import { component } from 'picoapp'
import { addItemById } from '../lib/cart'

export default component((node) => {
    const triggers = document.querySelectorAll('[data-toggle-gwp-drawer]')
    const closers = node.querySelectorAll('[data-toggle]')
    const form = node.querySelector('form')

    const open = () => {
        node.classList.add('is-active')

        setTimeout(() => {
            node.classList.add('gwp-is-visible')
            document.body.classList.add('gwp-is-visible')
        }, 50)
    }

    const close = () => {
        node.classList.remove('gwp-is-visible')
        document.body.classList.remove('gwp-is-visible')
        setTimeout(() => {
            node.classList.remove('is-active')
        }, 400)
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault()

        const input = form.querySelector('input:checked')

        if (input) {
            addItemById(parseInt(input.value, 10), 1, () => {
                close()
            })
        }
    })

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()

            open()
        })
    })

    closers.forEach((button) => {
        button.addEventListener('click', close)
    })
})
